module.exports = __webpack_public_path__ + "img/143.3c79134b.jpg";